import React from 'react';
import { Outlet } from 'react-router-dom';

const Education = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Education;
